import React, { useState, useEffect } from 'react';
import { usePopper } from 'react-popper';
import { ClickAwayListener } from '@mui/material';
import { styled } from '@mui/material/styles';

const Arrow = styled("div") `
    height: 1.125rem;
    margin-top: -1.0625rem;
    position: absolute;
    font-size: 1.125rem;
    &[data-placement*="bottom"] {
        top: 0.375rem;
        &::before {
            border-bottom: none;
            ${({ theme: { direction } }) => (direction === "ltr" ? "border-right: none" : "border-left: none")};
        }
    }
    &[data-placement*="top"] {
        bottom: -0.375rem;
        &::before {
            border-top: none;
            ${({ theme: { direction } }) => (direction === "ltr" ? "border-left: none" : "border-right: none")};
        }
    }
    &::before {
        width: 1.375rem;
        height: 1.375rem;
        margin: auto;
        content: "";
        display: block;
        background: ${({ theme }) => theme.colours.popover.backgroundColour};
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        border: ${({ theme }) => theme.colours.popover.border};
    }
`;

let timerId;
const Tooltipv2 = ({ children, referenceElement, timeout = undefined, handleClose, boundaryElement }) => {
    var _a;
    const [popperElement, setPopperElement] = useState(null);
    const [arrowElement, setArrowElement] = useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        modifiers: [
            { name: "arrow", options: { element: arrowElement } },
            { name: "offset", options: { offset: [18, 18] } },
            {
                name: "flip",
                options: {
                    fallbackPlacements: ["top"],
                    boundary: boundaryElement,
                },
            },
        ],
    });
    const setMouseOut = () => {
        if (timeout) {
            clearTimeout(timerId);
            timerId = setTimeout(handleClose, timeout);
        }
    };
    useEffect(() => {
        setMouseOut();
    });
    const setMouseIn = () => {
        if (timeout)
            clearTimeout(timerId);
    };
    const currentPlacement = (_a = attributes.popper) === null || _a === void 0 ? void 0 : _a["data-popper-placement"];
    return (React.createElement("div", Object.assign({ ref: setPopperElement, style: styles.popper }, attributes.popper, { onMouseLeave: setMouseOut, onMouseEnter: setMouseIn }),
        React.createElement(Arrow, { ref: setArrowElement, "data-placement": currentPlacement, style: styles.arrow }),
        React.createElement(ClickAwayListener, { onClickAway: handleClose }, children)));
};

export { Tooltipv2 as default };
